import { useCallback, useEffect } from "react";
import {
  AnyInnerMessage,
  AnyOuterMessage,
  BindMessage,
  CallMethodMessage,
  InnerMessageType,
  OuterMessageType,
} from "../../external/message-types";
import useHighlightApi from "../HighlightPopover/useHighlightApi";
import useNavApi from "../nav/useNavApi";
import useViewer from "../viewer-context/useViewer";

function postMessage(msg: AnyInnerMessage, origin: string) {
  window.parent.postMessage(msg, origin);
}

/**
 * This is a component so we can use the react-based viewer context
 */
export default function ExternalAPIReceiver() {
  const { viewer, bookData } = useViewer();

  const api = {
    ...useHighlightApi(),
    ...useNavApi(),
  };

  const onMessage = useCallback(
    (messageEvent: MessageEvent) => {
      const baseData = messageEvent.data as AnyOuterMessage;
      const { type, uuid } = baseData;

      if (type === OuterMessageType.CALL_METHOD) {
        const { method, args } = baseData as CallMethodMessage;

        // @ts-ignore
        const result = api[method](...args);
        if (result) {
          result.then((resp: crane.ResponseData) => {
            postMessage(
              {
                type: InnerMessageType.RESOLVE_METHOD,
                uuid,
                data: resp,
              },
              messageEvent.origin
            );
          });
        }
      } else if (type === OuterMessageType.BIND_EVENT) {
        const { event } = baseData as BindMessage;
        document.addEventListener(event, (eventObj: any) => {
          postMessage(
            {
              type: InnerMessageType.DISPATCH_EVENT,
              data: eventObj.detail,
              uuid,
            },
            messageEvent.origin
          );
        });
      } else if (type === OuterMessageType.CHECK_API) {
        if (viewer) {
          postMessage(
            {
              type: InnerMessageType.ACK_API,
              uuid,
              data: bookData as jigsaw.BookData,
            },
            messageEvent.origin
          );
        }
      }
    },
    [api, bookData, viewer]
  );

  useEffect(() => {
    window.addEventListener("message", onMessage, false);
    return () => {
      window.removeEventListener("message", onMessage, false);
    };
  }, [onMessage]);

  return null;
}
